import { getCookie } from 'cookies-next';

import { DRM_CAPABILITIES_COOKIE } from '@/utils/constants/common';

/**
 * True once client capability detection has persisted its cookies. DRM detection is the async
 * capability — its cookie is written only when detection settles (right before the host flips
 * `capabilitiesReady`), and DNT is written synchronously alongside — so the DRM cookie's presence
 * mirrors the host `capabilitiesReady` gate for non-React callers (e.g. the video MFE's recovery
 * path), letting them avoid a restart that would mint a JWT with null device/DRM claims.
 */
export function areClientCapabilitiesReady(): boolean {
    return getCookie(DRM_CAPABILITIES_COOKIE) !== undefined;
}
